<script setup lang="ts">
import TopHeader from "@/components/TopHeader.vue";
import "@/assets/css/styles.scss"
import 'primeicons/primeicons.css'
import {useScroll} from "@vueuse/core";

const el = ref<HTMLElement | null>(null)
const {y} = useScroll(el,)
const router = useRouter()
const route = useRoute()
const baseUrl = 'https://mody.at'

watch(router.currentRoute,()=>{
  console.log(router.currentRoute.value.fullPath)
  if(!router.currentRoute.value.fullPath.includes("/shop/category")){
    setTimeout(()=>{
      y.value = 0;
    },100)
  }
})
useHead({
  htmlAttrs: {
    lang: 'de',
  },
  link: [
  {
    rel: 'canonical',
    href: baseUrl + route.fullPath.split('?')[0], // Querystrings entfernen
  }
  ]
})

const hideMenu = computed(() => {
  return router.currentRoute.value.fullPath.includes("/landingpages")
})

</script>

<template>
  <CookieControl locale="de" />
  <TopHeader v-if="!hideMenu"/>
  <div>
    <NuxtPage />
    <Footer/>
  </div>
  
</template>

<style lang="scss">
@import url("bootstrap/dist/css/bootstrap-grid.css");
@import url("bootstrap/dist/css/bootstrap-utilities.css");
/*.p-scrollpanel{
  height: calc(100% - 76px);
  .p-scrollpanel-content{
    scroll-snap-type: y proximity;
    padding:0;
    width: unset;*/
    
    .slot {
      min-height: 100vh;
      position: relative;
      scroll-snap-align: start;
      overflow:hidden;
    }
    /*  }*/
    .p-scrollpanel-bar{
      display:none;
    }
    /*}*/
    a{
      color:unset;
    }
    html,body, #__nuxt, #__layout{
      width:100vw;
      overflow-x: hidden;
      margin:0;
    }
  </style>
  